import styles from './rating.module.scss';
import MaterialRating from '@mui/material/Rating';

/* eslint-disable-next-line */
export interface RatingProps {
  // classes?: object,
  // defaultValue?: number,
  disabled?: boolean,
  // emptyIcon?: ReactNode,
  // emptyLabelText?: ReactNode,
  // getLabelText?: (value: number) => string,
  // highlightSelectedOnly?: boolean,
  // icon?: ReactNode,
  // IconContainerComponent?: any,
  max?: number,
  name?: string;
  onChange?: (event: any, value: number | null) => void;
  // onChangeActive?: (event: any, value: number) => void,
  // precision?: number,
  // readOnly?: boolean,
  size?: 'small' | 'medium' | 'large';
  // sx?: any,
  value?: number;
  className?: string
}

export function Rating(props: RatingProps) {
  return (
    <MaterialRating
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      size={props.size}
      disabled={props.disabled}
      max={props.max}
      className={props.className}
    />
  );
}

export default Rating;